import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import {
  Wifi,
  AcUnit,
  Pets,
  FreeBreakfast,
  LocalParking,
  Pool,
  SmokeFree,
  Star,
} from '@mui/icons-material';

export {}; // Make this a module

interface Board {
  amenities?: string[];
}

interface AmenitiesSectionProps {
  board: Board | null;
}

const AmenitiesSection: React.FC<AmenitiesSectionProps> = ({ board }) => {
  const amenities = board?.amenities && Array.isArray(board.amenities) ? board.amenities : [];
  if (amenities.length === 0) return null;

  const getAmenityIcon = (amenity: string) => {
    if (amenity.toLowerCase().includes('wifi')) return <Wifi />;
    if (amenity.toLowerCase().includes('aire') || amenity.toLowerCase().includes('ac')) return <AcUnit />;
    if (amenity.toLowerCase().includes('pet') || amenity.toLowerCase().includes('mascota')) return <Pets />;
    if (amenity.toLowerCase().includes('desayuno')) return <FreeBreakfast />;
    if (amenity.toLowerCase().includes('estacionamiento')) return <LocalParking />;
    if (amenity.toLowerCase().includes('piscina')) return <Pool />;
    if (amenity.toLowerCase().includes('fumadores') || amenity.toLowerCase().includes('no fumar')) return <SmokeFree />;
    return <Star />;
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        ✨ Amenities Incluidos
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
        {amenities.map((amenity, index) => (
          <Chip
            key={index}
            icon={getAmenityIcon(amenity)}
            label={amenity}
            variant="outlined"
            sx={{
              borderRadius: 2,
              py: 1,
              px: 0.5,
              bgcolor: 'primary.light',
              color: 'primary.contrastText',
              '& .MuiChip-icon': { color: 'inherit' }
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default AmenitiesSection;